"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcAggregateRating = exports.detInventoryFlag = exports.splitIntoTwo = exports.arrayInsert = exports.generateRandomId = exports.firstCapital = exports.isBlank = exports.isEmpty = exports.pluralizeNoCount = exports.pluralize = exports.notEmpty = exports.sleep = exports.distinct = exports.groupBy = void 0;
function groupBy(items, keyExtractor) {
    var map = new Map();
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        var key = keyExtractor(item);
        var group = map.get(key);
        if (!group) {
            group = [];
            map.set(key, group);
        }
        group.push(item);
    }
    return map;
}
exports.groupBy = groupBy;
function distinct(array) {
    var j = {};
    array.forEach(function (v) {
        j["".concat(String(v), "::").concat(typeof v)] = v;
    });
    return Object.keys(j).map(function (v) { return j[v]; });
}
exports.distinct = distinct;
function sleep(milliseconds) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, milliseconds); })];
        });
    });
}
exports.sleep = sleep;
function notEmpty(value) {
    return value !== null && value !== undefined;
}
exports.notEmpty = notEmpty;
function pluralize(count, noun, suffix) {
    if (suffix === void 0) { suffix = 's'; }
    return "".concat(count, " ").concat(noun).concat(count !== 1 ? suffix : '');
}
exports.pluralize = pluralize;
function pluralizeNoCount(count, noun, suffix) {
    if (suffix === void 0) { suffix = 's'; }
    return "".concat(noun).concat(count !== 1 ? suffix : '');
}
exports.pluralizeNoCount = pluralizeNoCount;
function isEmpty(str) {
    return !str || str.length === 0;
}
exports.isEmpty = isEmpty;
function isBlank(str) {
    return !str || /^\s*$/.test(str);
}
exports.isBlank = isBlank;
function firstCapital(str) {
    return str.length > 0 ? str[0].toUpperCase() + str.substr(1) : str;
}
exports.firstCapital = firstCapital;
function generateRandomId(length, alphabet) {
    if (alphabet === void 0) { alphabet = 'ABCDEFGHIJKLMNPQRSTUVWXYZ123456789'; }
    var alphabetLength = alphabet.length;
    var result = [];
    for (var i = 0; i < length; i += 1) {
        result.push(alphabet.charAt(Math.floor(Math.random() * alphabetLength)));
    }
    return result.join('');
}
exports.generateRandomId = generateRandomId;
var arrayInsert = function (array, item, index) { return __spreadArray(__spreadArray(__spreadArray([], array.slice(0, index), true), [item], false), array.slice(index), true); };
exports.arrayInsert = arrayInsert;
function splitIntoTwo(input, sep) {
    var pos = input.indexOf(sep);
    if (pos < 0) {
        return [input, ''];
    }
    return [input.substr(0, pos), input.substr(pos + sep.length)];
}
exports.splitIntoTwo = splitIntoTwo;
function detInventoryFlag(spots, spotsBooked) {
    if (spots === 0) {
        return 'zero';
    }
    if (spots === spotsBooked) {
        return 'out';
    }
    if (spotsBooked / spots >= 0.4) {
        return 'trend';
    }
    return 'default';
}
exports.detInventoryFlag = detInventoryFlag;
function calcAggregateRating(reviews) {
    if (reviews.length === 0) {
        return -1;
    }
    var total = 0;
    reviews.forEach(function (review) {
        total += review.starRating;
    });
    // component only allows 1/2 stars, truncates if not x.5
    return Math.ceil((total / reviews.length) * 2) / 2;
}
exports.calcAggregateRating = calcAggregateRating;
//# sourceMappingURL=Generic.js.map